import React from 'react';

export default ({ icon }) => <i className={`fas ${icon || ''}`} />;
